import React, { useState, useEffect } from 'react';
import axiosInstance from '../../utils/router/axiosInstance';
import CabinetShell from '../../components/UI/CabinetShell/cabinetShell';
import './settings.css';
import ColibrateTable from './Colibrate/colibrateTable';
import BuildingHeader from './Colibrate/building';
import UserColibrate from './Colibrate/userColibrate';
import MapCalibrationPanel from './Colibrate/mapCalibrationPanel';
import SettingsNav from '../../components/UI/SettingsNav/settingsNav';
import { logger } from '../../utils/logger';

const Wifi = () => {
  const [activeLink, setActiveLink] = useState(null);
  const [data, setData] = useState([]);
  const [newdata, setNewData] = useState([]);
  const [selectedFloor, setSelectedFloor] = useState(1);
  const [selectedBuilding, setSelectedBuilding] = useState('');
  const [selectedBuildingId, setSelectedBuildingId] = useState('');

  const handleBuildingChange = (buildingId) => {
    setSelectedBuildingId(buildingId);
  };
  const handleDataChange = (updatedData) => {
    setNewData(updatedData);
  };

  const handleBuildingAndFloorChange = (building, floor) => {
    setSelectedBuilding(building);
    setSelectedFloor(floor);
  };

  useEffect(() => {
    if (!selectedBuildingId || !selectedFloor) return;
    setData([]);
    const fetchData = async () => {
      try {
        const floors = await axiosInstance.get(`website/floors/${selectedBuildingId}`).then((res) => res.data.floors);

        const floorID = floors?.find((floor) => floor.floor === selectedFloor).floor_id || 1;

        const response = await axiosInstance.get(`/website/dots?building_id=${selectedBuildingId}&floor_id=${floorID}`);
        setData(response.data);
      } catch (error) {
        logger.error('Error fetching data:', error);
      }
    };

    fetchData();
    setActiveLink(`${window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1)}`);
  }, [selectedBuildingId, selectedFloor]);

  return (
    <CabinetShell title="Wi-Fi точки" floor={false}>
      <SettingsNav activeLink={activeLink} setActiveLink={setActiveLink} />

      <div className="settingsContentWifi">
        <div className="TableBuilding">
          <BuildingHeader
            onBuildingAndFloorChange={handleBuildingAndFloorChange}
            onBuildingChange={handleBuildingChange}
            selectedFloorMain={setSelectedFloor}
          />
          <ColibrateTable
            data={data}
            onDataChange={handleDataChange}
            building={selectedBuilding}
            floor={selectedFloor}
          />
        </div>
        <div className="UserColibrateComponent">
          <UserColibrate
            data={newdata}
            fullData={data}
            selectedBuildingId={selectedBuildingId}
            selectedFloorId={parseInt(selectedFloor)}
          />
          <MapCalibrationPanel selectedBuildingId={selectedBuildingId} selectedFloor={selectedFloor} />
        </div>
      </div>
    </CabinetShell>
  );
};

export default Wifi;
